import React, { useCallback } from 'react';
import createHOC from 'react-create-hoc';
import { AuthProvider } from './AuthProvider';
import CloudAuthenticationContext from "./CloudAuthenticationContext";
import { useHistory, useLocation } from 'react-router-dom';

/**
 * Creates a content wrapped with CloudAuthenticationContext
 *
 * @function withAuthenticationProvider
 * @memberof module:digital-auth-react
 *
 * @param {ReactElement} ComponentToWrap component to be wrapped with AuthContextProvider.
 * @param {Object} authProps authorization passed to CloudAuthenticationContext
 * @see {@link module:digital-auth-react.CloudAuthenticationContext} for more information
 *
 * @returns {ReactElement} the content wrapped with CloudAuthenticationContext
 */

const withAuthenticationProvider = createHOC('withAuthenticationProvider', (ComponentToWrap, authProps) => {
   
    return function WithAuthenticationProvider(props) {
        const history = useHistory();
        const onLocationChange = useCallback(
            (newPath) => history.replace(newPath),
            [history]
        );
        let unSecureRoute = false;
        if (authProps.unsecuredRoutes) {
            const pathName = useLocation()?.pathname;
            unSecureRoute = authProps.unsecuredRoutes.some(route => route.test(pathName));
        }

        return (
            unSecureRoute ?
                <ComponentToWrap {...props} /> :
                <AuthProvider onLocationChange={onLocationChange}>
                    <CloudAuthenticationContext {...authProps}>
                        <ComponentToWrap {...props} />
                    </CloudAuthenticationContext>
                </AuthProvider> 
        );
    };
    },
    { factory: true, allowExtraProps: true }
);

export default withAuthenticationProvider;
